//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.Electrical.js";
import "../no/TaggedObjectCollection.js";
import "../no/Routing.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["connector_type","component_name"],"CreateConnectorDevice",{R_:{connector_device:"Routing.Electrical.ConnectorDevice"}},2,0],[["harness_device","equipment_name","connector_name","connector_type"],"CreateConnectorDevice1",{R_:{connector_device:"Routing.Electrical.ConnectorDevice"}},4,0],[["no_of_connectors"],"GetConnectorSingleDevices",{R_:{connectors:"Routing.Electrical.ConnectorDevice[]"}},0,0],[["no_of_equipment"],"GetEquipmentSingleDevices",{R_:{equipment:"Routing.Electrical.ConnectorDevice[]"}},0,0],[["connectors"],"AutoAssignConnectors",{},1,0],[["spliceName"],"GetSpliceConnectorDevice",{R_:{spliceSingleDevice:"Routing.Electrical.ConnectorDevice"}},1,0]],[]];
SPLM.Routing.Electrical.ConnectorDeviceCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.Electrical.ConnectorDeviceCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;